import React from "react"
import styled from "styled-components"

import { League } from "../types"

interface TableViewProps {
  leagues: Array<League>
}

export default function TableView({ leagues }: TableViewProps) {
  return (
    <Table>
      <thead>
        <tr>
          <th>League</th>
          <th>Started</th>
          <th>Ended</th>
          <th style={{ textAlign: "center" }}>Players</th>
          <th style={{ textAlign: "center" }}>Rating</th>
          <th style={{ textAlign: "center" }}>Reviews</th>
        </tr>
      </thead>
      <tbody>
        {leagues.map((l) => (
          <tr key={l.id}>
            <td>{l.nameWithoutCourse}</td>
            <td>{l.startMonthAndDate}</td>
            <td>{l.endMonthAndDate}</td>
            <td style={{ textAlign: "center" }}>{l.playerCount}</td>
            <td style={{ textAlign: "center" }}>{l.ratingsCount ? `${l.positiveRatingPercent}%` : "-"}</td>
            <td style={{ textAlign: "center" }}>{l.ratingsCount ? l.ratingsCount : "-"}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

const Table = styled.table`
  th {
    padding-right: 0 !important;
  }
`
